import PropTypes from 'prop-types';
import { FormProvider as Form } from 'react-hook-form';
import './FormProvider.css'; // Import your CSS file

export default function FormProvider({ children, onSubmit, methods, disabled }) {
  const isAllowedInDisabledMode = (target) =>
    target instanceof Element && Boolean(target.closest('.doNotDisable'));

  const isScrollOnlyElement = (target) => target.closest('.scrollOnly') !== null;

  const handleSubmit = disabled
    ? (event) => {
        event.preventDefault();
      }
    : onSubmit;

  const handleFocusCapture = (event) => {
    if (
      disabled &&
      event.target instanceof HTMLTextAreaElement &&
      event.target.readOnly &&
      isScrollOnlyElement(event.target)
    ) {
      return;
    }
    if (!disabled || isAllowedInDisabledMode(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.target instanceof HTMLElement) {
      event.target.blur();
    }
  };

  const handleKeyDownCapture = (event) => {
    if (!disabled || isAllowedInDisabledMode(event.target)) return;
    if (isScrollOnlyElement(event.target)) {
      if (
        event.target instanceof HTMLTextAreaElement &&
        event.target.readOnly &&
        ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)
      ) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClickCapture = (event) => {
    if (!disabled) return;
    if (isScrollOnlyElement(event.target)) {
      if (
        event.target instanceof HTMLTextAreaElement &&
        event.target.readOnly
      ) {
        return;
      }
      // Block clicks (add/remove chips, open dropdown)
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Form {...methods}>
      <form
        onSubmit={handleSubmit}
        className={disabled ? 'form-provider-disabled' : ''}
        onFocusCapture={handleFocusCapture}
        onKeyDownCapture={handleKeyDownCapture}
        onClickCapture={handleClickCapture}
      >
        {children}
      </form>
    </Form>
  );
}

FormProvider.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
};
